module.exports = __webpack_public_path__ + "img/Developers.4c8a158b.svg";